import { FC, useEffect } from "react";

import { blockchain } from "../../../settings";
import { useStoreDispatch, useStoreSelector } from "../../../store/store";
import { getContractTime } from "../../../utils/Binance/getContractTime";
import { getTime } from "../../../utils/Chromia/getTime";
import { updateDeposits as updateChrDeposits } from "../../../utils/Chromia/updateDeposits";
import { updateDeposits as updateBscDeposits } from "../../../utils/helpers";

const oneDay = 24*60*60;


const MainUpdater: FC = () => {

	const {appContracts, discountPercent, currentTimes, apiData, userAddress} = useStoreSelector(store => store.app);
	const {chrClientAddr, items, endTimes} = useStoreSelector(store => store.chromia);
	const {setIsDepositAvailable} = useStoreDispatch();

	useEffect(() => {
		let interval: NodeJS.Timer | undefined = undefined;
		switch (blockchain) {
			case 'binance':
				if (appContracts[discountPercent]){
					getContractTime(discountPercent);
					interval = setInterval(() => {
						getContractTime(discountPercent);
					}, 15000);
				}
				break;

			case 'chromia':
				getTime();
				interval = setInterval(() => {
					getTime(discountPercent);
				}, 15000);
				break;
		}

		return () => {
			interval && clearInterval(interval);
		}
		// eslint-disable-next-line
	}, [discountPercent, appContracts]);

	useEffect(() => {
		switch (blockchain) {
			case 'binance':
				if (currentTimes[discountPercent] && apiData[discountPercent]){
					setIsDepositAvailable(discountPercent, currentTimes[discountPercent]!.ts < apiData[discountPercent]!.config.sbd.end_time - oneDay);
				}
				break;

			case 'chromia':
				setIsDepositAvailable(
					discountPercent,
					(items[discountPercent] && currentTimes[discountPercent])
						? endTimes[discountPercent] - items[discountPercent]!.per_time > currentTimes[discountPercent]!.ts
						: false
				)
				break;

			default:
				break;
		}
		// eslint-disable-next-line
	}, [currentTimes, apiData, discountPercent, items])

	useEffect(() => {
		let interval: NodeJS.Timer | undefined = undefined;
		if (blockchain === 'binance' && userAddress && apiData[discountPercent]){
			updateBscDeposits(discountPercent);
			interval = setInterval(() => {
				updateBscDeposits(discountPercent);
			}, 15000)
		}

		return () => {
			interval && clearInterval(interval);
		}
		// eslint-disable-next-line
	}, [discountPercent, apiData, userAddress])

	useEffect(() => {
		let interval: NodeJS.Timer | undefined = undefined;
		if (blockchain === 'chromia'){
			updateChrDeposits();

			interval = setInterval(() => {
				updateChrDeposits();
			}, 15000)
		}

		return () => {
			interval && clearInterval(interval);
		}
		// eslint-disable-next-line
	}, [chrClientAddr, discountPercent]);


	return null;
}

export default MainUpdater;